import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import styled from 'styled-components';

import { ContentSet } from 'components/Shared/Scaffolding';
import SettingsGroup, { SettingsHelper } from 'components/Shared/SettingsGroup';
import { Input, ButtonSet } from 'components/Shared/Forms';
import { TextButton } from 'components/Shared/Buttons';
import { saveDetails, getDetails } from 'modules/mapDetails';
import { SETTINGS_GROUP } from 'theme';

const StyledSettingsHelper = styled(SettingsHelper)`
    margin-top: -${SETTINGS_GROUP.PADDING.Y};
`;

const SaveForm = ({ handleSubmit, onCancel, submitting }) => {
    return (
        <form onSubmit={handleSubmit}>
            <ContentSet spacing="40px">
                <SettingsGroup name="Map Name" description="Enter a name for your map.">
                    <Input name="name" type="text" required width="100%" />
                </SettingsGroup>
                <SettingsGroup name="Google Maps API Key" description="Enter an API Key for your map.">
                    <StyledSettingsHelper highlight="info">
                        <strong>Note:</strong> In order to use Google Maps on your site you must sign up for an API Key
                        with Google.{' '}
                        <a
                            href="https://developers.google.com/maps/documentation/javascript/get-api-key"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Click here
                        </a>{' '}
                        to get an API key and paste it below when you have created one.
                    </StyledSettingsHelper>
                    <Input name="apiKey" type="text" width="100%" />
                </SettingsGroup>
                <ButtonSet>
                    <TextButton primary loading={submitting} type="submit">
                        Save
                    </TextButton>
                    <TextButton secondary type="button" onClick={onCancel}>
                        Cancel
                    </TextButton>
                </ButtonSet>
            </ContentSet>
        </form>
    );
};

const form = 'save';

const onSubmit = (values, dispatch, props) => {
    return dispatch(saveDetails(values, props.id));
};

const mapStateToProps = (state) => ({
    initialValues: { ...getDetails(state) },
});

export default connect(mapStateToProps)(reduxForm({ form, onSubmit })(SaveForm));
